import type { C1_Button } from "../model/C1_Button";
import type { C1_Consumer } from "../model/C1_Consumer";
import { C1_EloItem_Type } from "../types/C1_EloTypes";

export function hasButtonEditorContent(item: C1_Button): boolean {
  if (item.owner?.isButton) return true;
  if (item.owner?.isSensor) return true;
  const definition = item.definition?.toDefinition();
  return (!definition || definition.type === C1_EloItem_Type.Button) && !!item.owner?.baseProps.buttonBaseProps;
}

export function hasLightEditorContent(item: C1_Consumer): boolean {
  return !!item.lightGroup || item.definition?.toDefinition().type === C1_EloItem_Type.Light;
}

export function hasConsumerEditorContent(item: C1_Consumer): boolean {
  return !!item.owner;
}
